import React from 'react';
import ScenarioAvatar from './ScenarioAvatar';
import './StartHereSlot.css';

/**
 * StartHereSlot — J2's editorial "start here" card (#1921), exported per
 * the #1921 blocking precondition so #1923's learner-home variant can reuse
 * it. Backed by #1903's ordering: editorial `sort_priority` first, the v0
 * shelf score as tiebreaker, floor-flagged scenarios excluded server-side —
 * this component only renders whatever the API decided, it makes no
 * ordering choice of its own (#1768 one-recommender constraint).
 *
 * "Most first-timers pick this" is the one social-proof line the gate
 * record keeps for this slot specifically (Journey Stitch J2) — distinct
 * from J3's shortlist, where the gate record explicitly REMOVES any ranking
 * claim from card copy. Do not copy this line onto ScenarioCard.
 *
 * Fix round 2026-08-24 (Gilbert): visually distinct from the ordinary
 * ScenarioCard/context-shelf rows below it — the persona avatar is LARGE
 * (`size="lg"`, vs ScenarioCard's `"md"`) and carries a brand-coloured ring
 * (`.gd-start-here__avatar-ring`) instead of the small ⭐ glyph the slot
 * used before avatars existed on any card; the "Start here" eyebrow keeps
 * its own pill treatment so the badge-of-distinction is legible even before
 * the avatar loads.
 */
function StartHereSlot({ card, onSelect }) {
  if (!card) return null;

  const durationMinutes = card.median_first_run_duration_minutes;
  const hasDuration = typeof durationMinutes === 'number' && durationMinutes > 0;

  return (
    <button
      type="button"
      className="gd-start-here"
      data-testid="gd-start-here"
      onClick={() => onSelect(card)}
    >
      <span className="gd-start-here__avatar-ring">
        <ScenarioAvatar avatarUrl={card.avatar_url} name={card.ai_role || card.name} size="lg" />
      </span>
      <span className="gd-start-here__text">
        <span className="gd-start-here__eyebrow">Start here</span>
        <span className="gd-start-here__title">{card.name}</span>
        <span className="gd-start-here__subtitle">
          Most first-timers pick this
          {hasDuration ? ` · ${durationMinutes} min` : ''}
          {card.prep_required ? '' : ' · no prep'}
        </span>
      </span>
      <span className="gd-start-here__chevron" aria-hidden="true">›</span>
    </button>
  );
}

export default StartHereSlot;
